/* MKE Ramadan-Kalender-Generator (Stand 06.10.2026): echte Zeiten aus ramadan-zeiten.js,
   Orte aus ramadan-orte-1..3.js. Braucht jsPDF (cdnjs). */
document.addEventListener("DOMContentLoaded",function(){
/* ============ KONFIGURATION ============ */
const CONFIG = {
  klaviyoCompanyId: "VfRaTP",
  klaviyoListId: "UCBK4G",          // NewsLetter (Double Opt-in). Alternative: "SGBb7T" Freebie Subscribers (Single Opt-in)
  klaviyoRevision: "2024-10-15",
  eventName: "Ramadan-Kalender erstellt",
  klaviyoLive: /(^|\.)muslim-kids\.de$/.test(location.hostname) || /[?&]klaviyo=live/.test(location.search),
  debug: /[?&]debug=1/.test(location.search)
};

/* ============ ORTE ============
   Format: [Name, Bundesland-Index, Breite, Länge, GeoNames-ID, Höhe m] */
const TEILE = window.MKE_STAEDTE_TEILE || [];
const CITIES = [].concat(TEILE[0]||[], TEILE[1]||[], TEILE[2]||[])
  .map(r=>({name:r[0],land:(window.MKE_LAND||[])[r[1]]||"",lat:r[2],lon:r[3],geonameId:r[4]||null,hoehe:r[5]||0}));

/* ============ ZEITEN ============ */
const DAYS = 30;
const Z = window.MKE_ZEITEN;
function getTimes(city){ return (city && Z) ? Z.ramadan2027(city) : []; }

/* ============ ZEICHNEN ============ */
const W=2480,H=3508;
const WD=["So","Mo","Di","Mi","Do","Fr","Sa"], MON=["Jan.","Feb.","März","Apr."];
function rr(c,x,y,w,h,r){c.beginPath();c.moveTo(x+r,y);c.arcTo(x+w,y,x+w,y+h,r);c.arcTo(x+w,y+h,x,y+h,r);c.arcTo(x,y+h,x,y,r);c.arcTo(x,y,x+w,y,r);c.closePath();}
function star(c,x,y,r,col){c.save();c.fillStyle=col;c.beginPath();for(let i=0;i<8;i++){const a=i*Math.PI/4,rad=i%2?r*.42:r;c.lineTo(x+Math.cos(a)*rad,y+Math.sin(a)*rad);}c.closePath();c.fill();c.restore();}
function crescent(c,x,y,r,col){const o=document.createElement("canvas");o.width=o.height=r*2+4;const k=o.getContext("2d");k.fillStyle=col;k.beginPath();k.arc(r+2,r+2,r,0,7);k.fill();k.globalCompositeOperation="destination-out";k.beginPath();k.arc(r+2+r*.42,r+2-r*.18,r*.86,0,7);k.fill();c.drawImage(o,x-r-2,y-r-2);}
function lantern(c,x,y,s,body,glow,line){
  c.save();c.strokeStyle=line;c.lineWidth=s*.04;c.beginPath();c.moveTo(x,0);c.lineTo(x,y);c.stroke();
  c.fillStyle=body;c.beginPath();c.moveTo(x-s*.18,y+s*.18);c.lineTo(x+s*.18,y+s*.18);c.lineTo(x+s*.08,y);c.lineTo(x-s*.08,y);c.closePath();c.fill();
  rr(c,x-s*.28,y+s*.18,s*.56,s*.78,s*.1);c.fill();
  c.fillStyle=glow;c.beginPath();c.moveTo(x-s*.15,y+s*.86);c.lineTo(x-s*.15,y+s*.45);c.quadraticCurveTo(x,y+s*.26,x+s*.15,y+s*.45);c.lineTo(x+s*.15,y+s*.86);c.closePath();c.fill();
  c.fillStyle=body;c.beginPath();c.moveTo(x-s*.2,y+s*.96);c.lineTo(x+s*.2,y+s*.96);c.lineTo(x,y+s*1.2);c.closePath();c.fill();c.restore();
}
function archPath(c,x,y,w,h){const ah=w*.55;c.beginPath();c.moveTo(x,y+h);c.lineTo(x,y+ah);c.bezierCurveTo(x,y+ah*.35,x+w*.35,y+ah*.12,x+w/2,y);c.bezierCurveTo(x+w*.65,y+ah*.12,x+w,y+ah*.35,x+w,y+ah);c.lineTo(x+w,y+h);c.closePath();}

/* Hintergrundbilder aus Shopify Files. */
function mkImg(src){const i=new Image();i.crossOrigin="anonymous";i.src=src;return i;}
const CDN="https://cdn.shopify.com/s/files/1/0870/7565/1850/files/";
const BG_NACHT =mkImg(CDN+"d950640a-1936-4687-b547-669cc3572956.png?v=1789715422&width=2480");
const BG_MORGEN=mkImg(CDN+"9b0ce6be-616c-41a2-a26e-f28ce93dac2c.png?v=1789715422&width=2480");
const KIDS_BG  =mkImg(CDN+"cd5d7a92-fe83-432e-aa32-a67e5b0f66ce.png?v=1789653510&width=2480");
function bgImage(c,img){
  if(img&&img.complete&&img.naturalWidth){
    const iw=img.naturalWidth, ih=Math.min(img.naturalHeight, iw*H/W);
    c.drawImage(img,0,0,iw,ih,0,0,W,H);
    return true;
  }
  return false;
}

const DESIGNS = {
  nacht:{
    name:"Sternennacht",
    bg(c){ if(bgImage(c,BG_NACHT)) return;
      const g=c.createLinearGradient(0,0,0,H);g.addColorStop(0,"#2a1e47");g.addColorStop(.45,"#3A2A5E");g.addColorStop(1,"#6B4E9E");c.fillStyle=g;c.fillRect(0,0,W,H);
      const pts=[[260,240,26],[520,120,16],[1900,200,22],[2200,420,30],[1640,90,14],[380,620,14],[2280,760,16],[980,150,12]];pts.forEach(p=>star(c,p[0],p[1],p[2],"#E8B84B"));
      crescent(c,2020,560,150,"#E8B84B");lantern(c,300,330,420,"#E8B84B","#F48FB1","#E8B84B");lantern(c,560,160,300,"#c99a34","#F9C6D8","#c99a34");},
    title:"#ffffff", sub:"#E8B84B", panel:"rgba(255,255,255,.96)", headBg:"#6B4E9E", headTx:"#ffffff", text:"#3A2A5E", alt:"#F4EEFA", accent:"#F48FB1", foot:"#ffffff"
  },
  morgen:{
    name:"Morgenrosa",
    bg(c){ if(bgImage(c,BG_MORGEN)) return;
      c.fillStyle="#ffffff";c.fillRect(0,0,W,H);
      c.fillStyle="#FDE3EC";archPath(c,50,110,2380,H-220);c.fill();
      c.fillStyle="#ffffff";archPath(c,120,230,2240,H-400);c.fill();
      c.strokeStyle="#E8B84B";c.lineWidth=10;archPath(c,85,170,2310,H-310);c.stroke();
      star(c,W/2,330,46,"#E8B84B");star(c,W/2-210,430,22,"#F48FB1");star(c,W/2+210,430,22,"#F48FB1");},
    title:"#6B4E9E", sub:"#c2185b", panel:"rgba(255,255,255,.88)", headBg:"#F48FB1", headTx:"#3A2A5E", text:"#3A2A5E", alt:"#FBEFF4", accent:"#E8B84B", foot:"#3A2A5E"
  },
  kinder:{
    name:"Kinderkalender",
    bg(c){ if(bgImage(c,KIDS_BG)) return; c.fillStyle="#fbf6ef";c.fillRect(0,0,W,H);},
    layout:{titleY:1090,titleSize:170,cityY:1210,citySize:96,subY:1285,subSize:52,top:1340,headH:120,rowH:60,fs:.92,footGap:72},
    title:"#1E4F58", sub:"#B07D1F", panel:"rgba(255,255,255,.55)", headBg:"#33808D", headTx:"#ffffff", text:"#1f2f3a", alt:"rgba(51,128,141,.09)", accent:"#E8B84B", foot:"#1f2f3a"
  }
};

function draw(canvas,designKey,city,times,{thumb=false}={}){
  const c=canvas.getContext("2d"),D=DESIGNS[designKey];
  c.save(); if(thumb){c.scale(canvas.width/W,canvas.height/H);}
  D.bg(c);
  const L=Object.assign({titleY:760,titleSize:190,cityY:900,citySize:104,subY:990,subSize:58,top:1060,headH:130,rowH:66,fs:1,footGap:95},D.layout||{});const F=n=>Math.round(n*L.fs);
  c.textAlign="center";c.fillStyle=D.title;
  c.font=`800 ${L.titleSize}px "Baloo 2", Figtree, sans-serif`;c.fillText("Ramadan 2027",W/2,L.titleY);
  c.fillStyle=D.sub;c.font=`700 ${L.citySize}px Figtree, sans-serif`;c.fillText(city?city.name:"Dein Ort",W/2,L.cityY);
  c.fillStyle=D.title;c.font=`400 ${L.subSize}px Figtree, sans-serif`;c.fillText("8. Februar bis 9. März 2027  |  Ramadan 1448",W/2,L.subY);

  const cols=[["Tag",275,"center"],["Datum",370,"left"],
    ["Sehri bis",760,"center","Essen bis","sehri19",1],["Fadschr",1000,"center","Morgengebet","fajrMwl",0],
    ["Schuruk",1240,"center","","shuruq",0],["Dhuhr",1480,"center","","dhuhr",0],["Asr",1720,"center","","asr",0],
    ["Iftar",1960,"center","Maghrib","maghrib",1],["Ischaa",2200,"center","","isha",0]];
  const x0=200,x1=W-200,top=L.top,rowH=L.rowH,headH=L.headH;
  if(D.panel){c.fillStyle=D.panel;rr(c,x0-30,top-30,x1-x0+60,headH+rowH*DAYS+60,40);c.fill();}
  c.fillStyle=D.headBg;rr(c,x0,top,x1-x0,headH,26);c.fill();
  c.fillStyle=D.headTx;
  cols.forEach(([t,x,a,sub])=>{c.textAlign=a;c.font=`700 ${F(44)}px Figtree, sans-serif`;c.fillText(t,x,top+(sub?headH*.46:headH*.6));
    if(sub){c.font=`400 ${F(30)}px Figtree, sans-serif`;c.globalAlpha=.85;c.fillText(sub,x,top+headH*.8);c.globalAlpha=1;}});

  (times||[]).forEach((t,i)=>{
    const y=top+headH+i*rowH;
    if(i%2){c.fillStyle=D.alt;c.fillRect(x0,y,x1-x0,rowH);}
    const base=y+rowH*.71;c.fillStyle=D.text;
    c.textAlign="center";c.font=`700 ${F(44)}px Figtree, sans-serif`;c.fillText(i+1,cols[0][1],base);
    if(i>=20) star(c,cols[0][1]+F(62),base-F(15),F(15),D.accent);
    c.textAlign="left";c.font=`400 ${F(40)}px Figtree, sans-serif`;
    c.fillText(`${WD[t.date.getDay()]}, ${t.date.getDate()}. ${MON[t.date.getMonth()]}`,cols[1][1],base);
    c.textAlign="center";
    cols.slice(2).forEach(([,x,,,key,bold])=>{c.font=`${bold?700:400} ${F(42)}px Figtree, sans-serif`;c.fillText(t[key]||"",x,base);});
  });

  const fy=top+headH+rowH*DAYS+L.footGap;
  c.textAlign="center";c.fillStyle=D.foot;
  c.font=`600 ${F(42)}px Figtree, sans-serif`;
  c.fillText("Sehri bis: Ende der letzten Mahlzeit vor dem Fasten. Fadschr: Beginn des Morgengebets.",W/2,fy);
  c.fillText("Sicherheitshalber: Sehri 1–2 Minuten früher beenden, Iftar 1–2 Minuten später beginnen.",W/2,fy+F(56));
  c.font=`400 ${F(36)}px Figtree, sans-serif`;
  c.fillText("Sterne markieren die letzten zehn Nächte. Der Ramadan kann 29 oder 30 Tage dauern.",W/2,fy+F(110));
  c.fillText("Für deinen Ort berechnet. Im Zweifel gilt die Zeit deiner Moschee.  |  muslim-kids.de",W/2,fy+F(160));
  c.restore();
}

/* ============ ZUSTAND UND UI ============ */
const state={city:null,design:"nacht"};
const $=id=>document.getElementById(id);
const page=$("page"), msg=$("msg"), logEl=$("log");
if(CONFIG.debug && $("devlog")) $("devlog").hidden=false;
const norm=s=>s.toLowerCase().replace(/ä/g,"ae").replace(/ö/g,"oe").replace(/ü/g,"ue").replace(/ß/g,"ss").normalize("NFD").replace(/[̀-ͯ]/g,"");
function log(title,obj){if(!logEl)return;const t=new Date().toLocaleTimeString("de-DE");logEl.textContent=(logEl.textContent==="Noch nichts gesendet."?"":logEl.textContent+"\n\n")+`[${t}] ${title}\n`+JSON.stringify(obj,null,2);}
const isKids=()=>state.design==="kinder";

function render(){
  draw(page,state.design,state.city,getTimes(state.city));
  $("prevLabel").textContent=state.city?`Vorschau: ${state.city.name}, Design ${DESIGNS[state.design].name}`:"Wähle einen Ort, um die Vorschau zu sehen.";
  const eb=$("emailBlock"); if(eb) eb.hidden=!isKids();
  $("dlPdf").textContent=isKids()?"Kinderkalender als PDF herunterladen":"Kalender als PDF herunterladen";
}

/* ============ ERFOLGSBEREICH MIT PRODUKTEN ============ */
function showSuccess(){
  const box=$("rkgSuccess"); if(!box) return;
  const kids=isKids();
  const erw=$("rkgCardsErw"), kid=$("rkgCardsKids");
  if(erw) erw.hidden=kids;
  if(kid) kid.hidden=!kids;
  const t=$("rkgSuccTitle"), l=$("rkgSuccLead"), m=$("rkgSuccMore");
  if(t) t.textContent=kids?"Dein Kinderkalender ist fertig":"Dein Kalender ist fertig";
  if(l) l.textContent=kids
    ? "Während dein Download läuft, schau dir gerne unsere passenden Bücher für den Ramadan mit Kindern an."
    : "Während dein Download läuft, schau dir gerne unsere passenden Bücher für den Ramadan an.";
  if(m){
    m.href=kids?"/collections/bucher":"/collections/bucher-fur-erwachsene";
    m.textContent=kids?"Alle Kinderbücher ansehen →":"Alle Bücher für Erwachsene ansehen →";
  }
  box.hidden=false;
  box.scrollIntoView({behavior:"smooth",block:"start"});
}

// Autovervollständigung
const input=$("city"),list=$("cityList");let hits=[],active=-1;
function showList(){
  const q=norm(input.value.trim());
  hits=q?CITIES.filter(c=>norm(c.name).startsWith(q)).concat(CITIES.filter(c=>!norm(c.name).startsWith(q)&&norm(c.name).includes(q))).slice(0,8):[];
  active=-1;list.innerHTML="";
  hits.forEach((c,i)=>{const li=document.createElement("li");li.id="opt"+i;li.setAttribute("role","option");li.textContent=c.name;const s=document.createElement("small");s.textContent=c.land;li.append(s);li.onmousedown=e=>{e.preventDefault();pick(c);};list.append(li);});
  if(q&&!hits.length){const li=document.createElement("li");li.textContent="Kein Ort gefunden. Versuch den nächstgrößeren Ort.";list.append(li);}
  list.hidden=!q;input.setAttribute("aria-expanded",String(!list.hidden));
}
function pick(c){state.city=c;input.value=c.name;list.hidden=true;input.setAttribute("aria-expanded","false");render();}
input.addEventListener("input",showList);
input.addEventListener("keydown",e=>{
  if(list.hidden||!hits.length)return;
  if(e.key==="ArrowDown"||e.key==="ArrowUp"){e.preventDefault();active=(active+(e.key==="ArrowDown"?1:-1)+hits.length)%hits.length;[...list.children].forEach((li,i)=>li.setAttribute("aria-selected",i===active));input.setAttribute("aria-activedescendant","opt"+active);}
  if(e.key==="Enter"){e.preventDefault();pick(hits[Math.max(active,0)]);}
  if(e.key==="Escape"){list.hidden=true;}
});
input.addEventListener("blur",()=>setTimeout(()=>list.hidden=true,120));

// Design-Auswahl mit Mini-Vorschau
function buildDesigns(){
  const box=$("designs");box.innerHTML="";
  const demo=state.city||CITIES[0]||null;
  Object.entries(DESIGNS).forEach(([key,D])=>{
    const b=document.createElement("button");b.type="button";b.setAttribute("aria-pressed",key===state.design);
    const cv=document.createElement("canvas");cv.width=248;cv.height=351;
    draw(cv,key,demo,getTimes(demo),{thumb:true});
    const l=document.createElement("b");l.textContent=D.name;b.append(cv,l);
    b.onclick=()=>{state.design=key;[...box.children].forEach(x=>x.setAttribute("aria-pressed",x===b));render();};
    box.append(b);
  });
}

/* ============ KLAVIYO UND DATALAYER ============ */
async function sendKlaviyo(email){
  const base="https://a.klaviyo.com/client/";
  const q=`?company_id=${CONFIG.klaviyoCompanyId}`;
  const headers={"Content-Type":"application/vnd.api+json","revision":CONFIG.klaviyoRevision};
  const sub={data:{type:"subscription",attributes:{
    custom_source:"Ramadan-Kalender-Generator",
    profile:{data:{type:"profile",attributes:{email,
      subscriptions:{email:{marketing:{consent:"SUBSCRIBED"}}},
      properties:{"Ramadan-Kalender Stadt":state.city.name}}}}},
    relationships:{list:{data:{type:"list",id:CONFIG.klaviyoListId}}}}};
  const ev={data:{type:"event",attributes:{
    properties:{Stadt:state.city.name,Bundesland:state.city.land,Design:DESIGNS[state.design].name,GeoNamesID:state.city.geonameId,Jahr:2027},
    metric:{data:{type:"metric",attributes:{name:CONFIG.eventName}}},
    profile:{data:{type:"profile",attributes:{email}}}}}};
  if(!CONFIG.klaviyoLive){log("Klaviyo (nur Protokoll, kein Versand): subscriptions",sub);log("Klaviyo (nur Protokoll, kein Versand): events",ev);return;}
  const r1=await fetch(base+"subscriptions/"+q,{method:"POST",headers,body:JSON.stringify(sub)});
  const r2=await fetch(base+"events/"+q,{method:"POST",headers,body:JSON.stringify(ev)});
  log("Klaviyo gesendet",{subscriptions:r1.status,events:r2.status});
  if(!r1.ok||!r2.ok) throw new Error("klaviyo");
}
function pushDataLayer(format){
  const e={event:"ramadan_kalender_download",kalender_stadt:state.city.name,kalender_bundesland:state.city.land,kalender_design:DESIGNS[state.design].name,kalender_format:format};
  window.dataLayer=window.dataLayer||[];window.dataLayer.push(e);log("dataLayer.push",e);
}

/* ============ DOWNLOAD ============ */
function offer(filename,blob){
  const a=document.createElement("a");a.href=URL.createObjectURL(blob);a.download=filename;document.body.append(a);a.click();
  setTimeout(()=>{URL.revokeObjectURL(a.href);a.remove();},2000);
}
function slug(s){return norm(s).replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,"");}

async function download(format){
  msg.className="msg";
  const kids=isKids();
  const email=($("email")||{value:""}).value.trim();
  if(!state.city){msg.className="msg err";msg.textContent="Wähle zuerst deinen Ort.";$("city").focus();return;}
  if(kids){
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){msg.className="msg err";msg.textContent="Gib eine gültige E-Mail-Adresse ein, zum Beispiel name@beispiel.de.";$("email").focus();return;}
    if(!$("consent").checked){msg.className="msg err";msg.textContent="Setz bitte das Häkchen, dann geht es los.";return;}
  }
  msg.textContent="Dein Kalender wird erstellt …";
  // Anmeldung darf den Download nie blockieren
  if(kids) sendKlaviyo(email).catch(()=>log("Klaviyo-Fehler","Anmeldung fehlgeschlagen, Download läuft trotzdem"));
  pushDataLayer(format);
  const name=`ramadan-kalender-2027-${slug(state.city.name)}`;
  try{
    if(format==="png"){
      const blob=await new Promise(r=>page.toBlob(r,"image/png"));
      offer(name+".png",blob);
    }else{
      const {jsPDF}=window.jspdf;const doc=new jsPDF({unit:"mm",format:"a4"});
      doc.addImage(page.toDataURL("image/jpeg",0.93),"JPEG",0,0,210,297);
      offer(name+".pdf",doc.output("blob"));
    }
    msg.textContent="Fertig. Dein Kalender liegt in deinen Downloads.";
    showSuccess();
  }catch(e){
    msg.className="msg err";
    msg.textContent="Der Download hat nicht geklappt. Versuch es bitte noch einmal.";
  }
}
$("dlPdf").onclick=()=>download("pdf");
$("dlPng").onclick=()=>download("png");

/* ============ START ============ */
function whenImagesReady(imgs,cb){
  let n=imgs.length;
  const done=()=>{ if(--n<=0) cb(); };
  imgs.forEach(i=>{ i.complete ? done() : (i.onload=done, i.onerror=done); });
}
Promise.all([document.fonts.load('800 100px "Baloo 2"'),document.fonts.load('700 40px Figtree'),document.fonts.load('400 40px Figtree')])
  .catch(()=>{}).finally(()=>whenImagesReady([BG_NACHT,BG_MORGEN,KIDS_BG],()=>{
    buildDesigns();render();
    const cc=$("cityCount");
    if(cc) cc.textContent = (CITIES.length>1000 && Z)
      ? `${CITIES.length.toLocaleString("de-DE")} Orte in Deutschland verfügbar.`
      : "Die Ortsliste lädt gerade nicht vollständig. Lade die Seite bitte neu.";
  }));
});
